import Vue from 'vue'
import { Spin } from 'ant-design-vue'

export function observeImageLoading(root, enabled = () => true) {
  const entries = new Map()
  const parents = new Map()

  function remove(image) {
    const entry = entries.get(image)
    if (!entry) return
    entry.spinner.$destroy()
    entry.overlay.remove()
    image.classList.remove('pc-image-placeholder')
    entries.delete(image)
    if (!Array.from(entries.values()).some(item => item.parent === entry.parent)) {
      if (parents.has(entry.parent)) entry.parent.style.position = parents.get(entry.parent)
      parents.delete(entry.parent)
    }
  }

  function update() {
    const pending = enabled() ? Array.from(root.querySelectorAll('img')).filter(image =>
      image.getAttribute('src') && image.loading !== 'lazy' && !image.complete
    ) : []
    for (const image of entries.keys()) {
      if (!pending.includes(image) || !root.contains(image)) remove(image)
    }
    for (const image of pending) {
      let rect = image.getBoundingClientRect()
      const style = getComputedStyle(image)
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        remove(image)
        continue
      }
      if ((!rect.width || !rect.height) && !image.closest('button, .brand, .fixed-tools')) {
        image.classList.add('pc-image-placeholder')
        rect = image.getBoundingClientRect()
      }
      if (rect.width < 48 && rect.height < 48 && /(?:\/icons\/|\.svg(?:[?#]|$))/i.test(image.getAttribute('src'))) continue
      let entry = entries.get(image)
      if (!entry) {
        const parent = image.parentElement
        if (!parent) continue
        if (getComputedStyle(parent).position === 'static') {
          parents.set(parent, parent.style.position)
          parent.style.position = 'relative'
        }
        const overlay = document.createElement('div')
        overlay.className = 'pc-image-loading'
        overlay.setAttribute('role', 'status')
        overlay.setAttribute('aria-label', '图片加载中')
        const tip = rect.width >= 80 && rect.height >= 80 ? '加载中...' : undefined
        const spinner = new Vue({ render: h => h(Spin, { props: { spinning: true, size: 'small', tip } }) }).$mount()
        overlay.appendChild(spinner.$el)
        entry = { parent, overlay, spinner }
        entries.set(image, entry)
        parent.appendChild(overlay)
      }
      const parentRect = entry.parent.getBoundingClientRect()
      Object.assign(entry.overlay.style, {
        left: `${rect.left - parentRect.left - entry.parent.clientLeft + entry.parent.scrollLeft}px`,
        top: `${rect.top - parentRect.top - entry.parent.clientTop + entry.parent.scrollTop}px`,
        width: `${rect.width}px`, height: `${rect.height}px`, borderRadius: style.borderRadius
      })
    }
  }
  const observer = new MutationObserver(update)
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'class'] })
  root.addEventListener('load', update, true)
  root.addEventListener('error', update, true)
  window.addEventListener('resize', update)
  update()
  return () => {
    observer.disconnect()
    root.removeEventListener('load', update, true)
    root.removeEventListener('error', update, true)
    window.removeEventListener('resize', update)
    for (const image of entries.keys()) remove(image)
  }
}
